import { render, staticRenderFns } from "./CollegiateMatchesPage.vue?vue&type=template&id=3f1201c8&scoped=true&"
import script from "./CollegiateMatchesPage.vue?vue&type=script&lang=js&"
export * from "./CollegiateMatchesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1201c8",
  null
  
)

export default component.exports